import { Injectable } from '@angular/core';
import { AppConfigService } from '../app-config.service';

@Injectable({
  providedIn: 'root'
})
export class UtilsService {

  constructor(
    private _environment: AppConfigService
  ) {
  }

  getUserBaseUri() {
    return this._environment.config.USER_BASE_URL;
  }

  getShiftJavaUri() {
    return this._environment.config.SHIFT_JAVA_URL;
  }

  getShiftManagementJavaUri() {
    return this._environment.config.INTERNAL_URL + '/shift-management';
  }

  getSchedulingBaseUri() {
    return this._environment.config.SCHEDULING_URL;
  }

  getShiftUri() {
    return this._environment.config.SHIFT_URL;
  }

  getICareUri() {
    return this._environment.config.ICARE_BASE_URL;
  }

  getBackgroundCheckUri() {
    return this._environment.config.BACKGROUND_CHECK_URL;
  }

  getQscoreUri() {
    return this._environment.config.INTERNAL_URL + '/qscore';
  }

  getAuthorizationBaseUri() {
    return this._environment.config.AUTH_BASE_URL;
    // return this._isLocalhost() ? environment.AUTH_BASE_URL :
    //   environment.AUTH_BASE_URL.replace('?', location.host);
  }

  getSocketBaseUri() {
    return this._environment.config.SOCKET_BASE_URL.replace('?', location.host);
  }

  getISystemBaseUri() {
    return this._environment.config.ISYSTEM_BASE_URL.replace('?', location.host);
  }

  getISystemBypassGatewayBaseUri() {
    return this._environment.config.ISYSTEM_BYPASS_GATEWAY_BASE_URL;
  }

  static getInitialsFromName(name: string): string {
    if (!name) {
      return '';
    }
    const initials = name.match(/\b\w/g) || [];
    return ((initials.shift() || '') + (initials.pop() || '')).toUpperCase();
  }

  getPayrollUrl() {
    return this._environment.config.INTERNAL_URL + '/payroll';
  }

  getVendorsUrl() {
    return this._environment.config.INTERNAL_URL + '/vendors';
  }

  private static _isLocalhost() {
    return false; // location.host === 'localhost:4222';
  }

}
